/* 部署环境枚举 */
export enum DeployEnvironment {
  Local = 'development',
  TencentTest = 'aibuild-tencent-test',
  TencentProd = 'aibuild-tencent-zprod',
}

/* 当前应用环境 */
export const APP_ENV = (__APP_MODE__ as DeployEnvironment) || DeployEnvironment.Local;

/* 是否为本地环境 */
export const isLocal = APP_ENV === DeployEnvironment.Local;

/* 是否为腾讯测试环境 */
export const isTencentTest = APP_ENV === DeployEnvironment.TencentTest;

/* 是否为腾讯生产环境 */
export const isTencentProd = APP_ENV === DeployEnvironment.TencentProd;

/* 是否为开发环境 */
export const isDevelopment = isLocal;

/* 是否为测试环境 */
export const isTest = isTencentTest;

/* 是否为线上环境 */
export const isOnline = isTencentProd;

/* CDN资源URL */
export const STATIC_URL = import.meta.env.PUBLIC_STATIC_URL;

/* 埋点上报URL */
export const DATA_URL = import.meta.env.PUBLIC_DATA_URL;

/* Google快捷登录应用ID */
export const GOOGLE_CLIENT_ID = import.meta.env.PUBLIC_GOOGLE_CLIENT_ID as string;
